<template>
  <div class="base-layout wrap">
    <p class="container-tit">
      {{ pageTitle }}
    </p>
    <Divider />
    <slot />
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  computed: {
    pageTitle() {
      return this.title || this.$route.meta.title
    }
  },
}
</script>

<style lang="less" scoped>
.base-layout{
  color: #585859;
  .container-tit{
      font-size: 22px;
      color: #3C3C3D;
      letter-spacing: 2.4px;
      line-height: 22px;
      margin-bottom: 45px;
      margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Layout/baseLayout.vue?50c3ba91